module.exports = __webpack_public_path__ + "media/images/kumu-step4-2f82d5fa12e36acdfbee4c7b979dd7f0.png";